export { default } from './BookmarkAlternate'
